import type { KyInstance } from 'ky';

import qs from 'qs';

import { CommonQueryParamsSingle, CommonResponseSingle } from '../common/common.interface';
import { ContactUs } from './contact-us.model';

export async function getContactUs(
  httpClient: KyInstance,
  options: CommonQueryParamsSingle,
): Promise<CommonResponseSingle<ContactUs>> {
  const searchParams = qs.stringify(options);
  return await httpClient.get('contact-us', { searchParams }).json();
}
